import React from 'react';
import { useIntl } from 'react-intl';

const MissingInspectionsTab = () => {
  const { messages } = useIntl();
  
  return (
    <div style={{ padding: '20px' }}>
      <h2>{messages['evirPx_missing_inspections']}</h2>
      <p>Missing inspections content will go here.</p>
    </div>
  );
};

export default MissingInspectionsTab;
